'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = generateCurlExample;
/**
 * Generates a cURL example
 * @param {object} req - An adapted request object
 * @param {string} comment - A comment for the code
 * @return {string} A code fragment.
 * @private
 */
function generateCurlExample(req, comment) {
	var example = ['-is'];

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = req.headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref = _step.value;

			var _ref2 = _slicedToArray(_ref, 2);

			var name = _ref2[0];
			var value = _ref2[1];

			example.push('-H', '"' + name + ': ' + value + '"');
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	switch (req.bodyType) {
		case 'string':
			// it is already a string, but should get quote and double-escape quotes
			example.push('-d', '' + JSON.stringify(req.body));
			break;
		case 'json':
			// the body is JSON, parse and stringify to prettify, and stringify
			// again (a string) to quote and double-escape quotes.
			example.push('-d', '' + JSON.stringify(JSON.stringify(req.body)));
			break;
		case 'form':
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = req.body[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step2.value;

					var _ref4 = _slicedToArray(_ref3, 2);

					var _name = _ref4[0];
					var _value = _ref4[1];

					example.push('-F');
					if (_value instanceof window.File) {
						if (_value.type) {
							example.push('"' + _name + '=@' + _value.name + ';type=' + _value.type + '"');
						} else {
							example.push('"' + _name + '=@' + _value.name + '"');
						}
					} else {
						example.push('"' + _name + '=' + _value + '"');
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			break;
		case 'file':
			example.push('--data-binary');
			example.push('"@' + req.body.name + '"');
			break;
	}

	example.push('-X', req.method.toUpperCase());
	example.push('"' + req.url + '"');

	return '# ' + comment + '\ncurl ' + example.join(' ');
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(generateCurlExample, 'generateCurlExample', 'src/utility/generateCurlExample.js');
}();

;